import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentFormattedFile } from '../../../../models/DocumentFormattedFile';
import { DocumentFormattedFileEdit } from '../../../../models/DocumentFormattedFileEdit';
import { DocumentLibraryConstants } from '../../../../../document/document-library-constants';
import { DocumentEffectiveAndPeriodicReviewDateDto } from '../../../../models/documentEffectiveAndPeriodicReviewDateDTO';
import { DocumentService } from '../../../../services/document.service';
import { PhaseValueConstants } from '../../../../../shared/constants/phaseValues-constants';
import { AuthenticationHelperService } from '../../../../../shared/components/authentication-maintainance/services/authentication-helper.service';
import { DocumentPersistenceService } from '../../../../../document/services/document-persistence.service';

@Component({
  selector: 'app-document-version-dates',
  templateUrl: './document-version-dates.component.html',
  styleUrls: ['./document-version-dates.component.scss']
})
export class DocumentVersionDatesComponent implements OnInit {
  @Input() closeDocVersionModalVisible!:boolean;
  @Output() setDocumentDetailsLoader = new EventEmitter<any>();
  @Output() closeDocVersionModal = new EventEmitter<boolean>();
  @Output() closeApprovalModal = new EventEmitter<boolean>();
  @Input() docEffectiveDate:any;
  @Input() docRequestedEffectiveDate:any;
  @Input() docPeriodicReviewCycle:any;
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() docVersionApprover!:any;
  @Input() isUpdateEffectiveDate : boolean = false;
  @Input() docPeriodicReviewDate ?: any;
  @Input() reasonForUpdatingEffectiveDate !: string
  @Input() phase ?: any;
  @Input() isEsignDialogForApproval!:any;
  @Input() isEsignDialogForDocumentDetailsUpdate!:any;
  errorMessages: string[] = [];
  documentVersionDatesModalDisplay: boolean=false;
  display: boolean = true;
  requestedEffectiveDate!:Date;
  effectiveDate:Date= new Date();
  currentDate:Date=new Date();
  minDateValue: Date = new Date();
  displayPeriodicReviewDate:boolean=false;
  documentEffectiveAndPeriodicReviewDto!:DocumentEffectiveAndPeriodicReviewDateDto;
  periodicReviewDate!:Date;
  isDisplayRequestedEffectiveDateControl!:boolean;
  documentFormattedFile !: DocumentFormattedFile;
  documentFormattedFileEdit !: DocumentFormattedFileEdit;
  showEsignatureConfirmationDialog:any=false;
  confirmationMessage:string=DocumentLibraryConstants.Doc_Version_Approval_Confirmation_Message;
  constructor(private documentsservice: DocumentService,private changeDetectorRef: ChangeDetectorRef,private messageService: MessageService, private readonly authenticationHelperService: AuthenticationHelperService,
    private documentPersistenceService: DocumentPersistenceService
  ) { }

  ngOnInit(): void { 
    this.setDocRequestedEffectiveDateControl();
    this.calculateDefaultEffectiveDate();
    this.calculateDefaultPeriodicReviewDate();
    this.setDefaultDateforSelection();   
    this.hidOrShowPeriodicReviewDateControl(); 
    this.documentVersionDatesModalDisplay=true;
  }

setDefaultDateforSelection(){
    this.minDateValue.setDate(this.currentDate.getDate());
}
setDocRequestedEffectiveDateControl(){
      if(this.docRequestedEffectiveDate === null)
      {
        this.isDisplayRequestedEffectiveDateControl=false;
      }
      else
      {
        this.isDisplayRequestedEffectiveDateControl=true;
      }
}
hidOrShowPeriodicReviewDateControl(){
  if(this.docPeriodicReviewCycle === DocumentLibraryConstants.PeriodicReviewCycle_UserDefined_OptionValue)
  {
    this.displayPeriodicReviewDate=true;
  }
  else
  {
    this.displayPeriodicReviewDate=false;
  }
}
  reloadDocumentVersionDatesModal()
  {
    this.closeDocVersionModalVisible=false;
    this.closeDocVersionModal.emit(this.closeDocVersionModalVisible);
  }

  calculateDefaultEffectiveDate()
  {
    if(this.phase == PhaseValueConstants.Approved){
      this.effectiveDate= new Date(this.docEffectiveDate);
      this.isDisplayRequestedEffectiveDateControl = false;
    }
    else if(this.docRequestedEffectiveDate === null)
    {
      this.effectiveDate.setDate(this.currentDate.getDate() + 14);
    }

    else if(formatDate(this.docRequestedEffectiveDate,'yyyy-MM-dd','en_US') < formatDate(this.currentDate,'yyyy-MM-dd','en_US'))
    {
      this.effectiveDate= new Date(this.currentDate);
    }
    else{
      this.effectiveDate= new Date(this.docRequestedEffectiveDate);
    }
  }

  calculateDefaultPeriodicReviewDate(){
    if(this.docPeriodicReviewDate !== null){
      this.periodicReviewDate= new Date(this.docPeriodicReviewDate);
    }
  }
  
  cancelClick()
  {
    this.documentVersionDatesModalDisplay=false;
    this.showEsignatureConfirmationDialog=false;
  }

  onConfirm(){
    this.authenticationHelperService.reauth(this.saveSignature.bind(this), this.closeConfirmationModal.bind(this));
  }

  saveSignature(){
    this.updateDatesInformationOnApproval();
  }

  updateDatesInformationOnApproval(){
    this.errorMessages = [];
    if(this.effectiveDate == null || (this.docPeriodicReviewCycle == DocumentLibraryConstants.PeriodicReviewCycle_UserDefined_OptionValue && this.periodicReviewDate == null)){
      if(this.effectiveDate == null){
        this.errorMessages.push(DocumentLibraryConstants.Document_ReadyForApproval_EffectiveDateRequired);
      }
      if(this.displayPeriodicReviewDate && this.periodicReviewDate == null){
        this.errorMessages.push(DocumentLibraryConstants.Document_ReadyForApproval_PeriodicDateRequired);
      }
    }
    else{

      // Convert strings to Date objects
      const periodicReviewDate = new Date(this.periodicReviewDate);
      const effectiveDate = new Date(this.effectiveDate);

      // Comparing dates
      if (periodicReviewDate < effectiveDate) {
          this.messageService.add({ 
              severity: DocumentLibraryConstants.Severity_Err, 
              summary: `${DocumentLibraryConstants.PeriodicReviewDate_PastDate}` 
          });
      }
      else
      {
      this.documentEffectiveAndPeriodicReviewDto={
      approver:this.docVersionApprover,
      version :this.documentVersion,
      number:this.documentNumber,
      periodicReviewCycle:this.docPeriodicReviewCycle,
      requestedEffectiveDate:this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(this.docRequestedEffectiveDate)),
      effectiveDate:this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(this.effectiveDate)),
      periodicReviewDate:this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(this.periodicReviewDate)),
      reasonForChangingEffectiveDate: this.reasonForUpdatingEffectiveDate
      }
      if(this.isUpdateEffectiveDate){
        // API will return polling headers - parent component will handle polling completion
        this.documentsservice.updateEffectiveAndPeriodicReviewDate(this.documentEffectiveAndPeriodicReviewDto).subscribe({
          next: (serviceData)=>{
            // Success - polling starts automatically, parent will close modal after completion
          },
          error: (err) => {
            // On error, close modals
            this.documentVersionDatesModalDisplay = false;
            this.showEsignatureConfirmationDialog = false;
            this.display = false;
            this.closeApprovalModal.emit(false);
            this.reloadDocumentVersionDatesModal();
          }
        })
      }
      else{
        // API will return polling headers - parent component will handle polling completion
        this.documentsservice.approveDocument(this.documentEffectiveAndPeriodicReviewDto)
        .subscribe({
          next: (serviceData) =>{
            // Success - polling starts automatically, parent will close modal after completion
          },
          error: (err) => {
            // On error, close modals
            this.documentVersionDatesModalDisplay = false;
            this.showEsignatureConfirmationDialog = false;
            this.display = false;
            this.closeApprovalModal.emit(false);
            this.reloadDocumentVersionDatesModal();
          }
        });
      }
    }      
  }
  }

  confirmClick()
  {
    if(this.isEsignDialogForApproval)
    {
      this.showEsignatureConfirmationDialog=true;
    }
    else if(this.isEsignDialogForDocumentDetailsUpdate)
    {
      this.authenticationHelperService.reauth(this.saveSignature.bind(this), this.closeConfirmationModal.bind(this));
    }
      else{
        this.updateDatesInformationOnApproval();
      }
  }

  setRequestedEEffectiveDate(){
    this.docEffectiveDate=new Date();
  }
  closeConfirmationModal(){
    this.showEsignatureConfirmationDialog=false;
  }


}
